export const APP_STATUS = {
  ACTIVE: "active",
  IDLE: "idle",
} as const

export type AppStatus = typeof APP_STATUS[keyof typeof APP_STATUS]

export const homeScreenMode = () => {
  if (!window.electron) return

  window.electron.sendMessage("setHomeScreenMode", { enable: true })
}

export const updateAppStatus = (status: AppStatus) => {
  if (!window.electron) return

  window.electron.sendMessage("updateAppStatus", { status })
}
